import logoStackedDark from 'assets/logo/variants/logo-stacked-dark.svg'

const logoMaskStyle = {
  maskImage: `url(${logoStackedDark})`,
  maskPosition: 'center',
  maskRepeat: 'no-repeat',
  maskSize: 'contain',
  WebkitMaskImage: `url(${logoStackedDark})`,
  WebkitMaskPosition: 'center',
  WebkitMaskRepeat: 'no-repeat',
  WebkitMaskSize: 'contain',
}

export function SplashScreen() {
  return (
    <div className="map-splash flex h-full items-center justify-center bg-white px-6" role="status">
      <div className="relative w-24 max-w-[42vw] shrink-0">
        <img
          src={logoStackedDark}
          alt="Mdigital Logo"
          width={96}
          height={96}
          className="block h-auto w-full"
        />
        <span
          className="map-splash-logo-shimmer pointer-events-none absolute inset-0"
          style={logoMaskStyle}
          aria-hidden="true"
        />
        <span className="sr-only">Загрузка карты</span>
      </div>
    </div>
  )
}
